import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=6cb34d10&functional=true&"
import script from "./Undo.vue?vue&type=script&lang=js&"
export * from "./Undo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb34d10')) {
      api.createRecord('6cb34d10', component.options)
    } else {
      api.rerender('6cb34d10', component.options)
    }
    module.hot.accept("./Undo.vue?vue&type=template&id=6cb34d10&functional=true&", function () {
      api.rerender('6cb34d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/Undo.vue"
export default component.exports